import { render, staticRenderFns } from "./form-billing-update.vue?vue&type=template&id=0a2742fa&"
import script from "./form-billing-update.vue?vue&type=script&lang=js&"
export * from "./form-billing-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports